var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 5.83333C3.33301 5.3731 3.7061 5 4.16634 5H15.833C16.2932 5 16.6663 5.3731 16.6663 5.83333C16.6663 6.29357 16.2932 6.66667 15.833 6.66667H4.16634C3.7061 6.66667 3.33301 6.29357 3.33301 5.83333Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 10C3.33301 9.53976 3.7061 9.16667 4.16634 9.16667H15.833C16.2932 9.16667 16.6663 9.53976 16.6663 10C16.6663 10.4602 16.2932 10.8333 15.833 10.8333H4.16634C3.7061 10.8333 3.33301 10.4602 3.33301 10Z",
    fill: "#222729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 14.1667C3.33301 13.7064 3.7061 13.3333 4.16634 13.3333H15.833C16.2932 13.3333 16.6663 13.7064 16.6663 14.1667C16.6663 14.6269 16.2932 15 15.833 15H4.16634C3.7061 15 3.33301 14.6269 3.33301 14.1667Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.017a9e5cadf7aa1dcd942be3bdfa9d7f.svg";
export { ForwardRef as ReactComponent };